<template>
  <div class="screen page dashboard b-soft">
    <div class="grid">
      <section class="layout">
        <div v-if="cotizaciones.length" class="container">
          <div class="row v-items-bottom">
            <div class="col">
              <p class="t-complementary">
                Cotizaciones Recientes
              </p>
            </div>
            <div class="col-auto">
              <p>
                <a href="#" class="t-10-px link" v-on:click.prevent="goTo('/cotizaciones')">
                  Ver Toda la Actividad
                </a>
              </p>
            </div>
          </div>
          <div class="row h-items-center">
            <div class="col-12 box-container b-white moves-container no-select">
              <ul class="list-container container">
                <li v-for="cotizacion in cotizaciones" v-bind:key="cotizacion.id" class="row v-items-center">
                  <div class="col" v-on:click.prevent="goTo('/cotizacion/'+cotizacion.id)">
                    <div class="container">
                      <div class="row v-items-center">
                        <div class="col-auto">
                          <span class="icon-list" v-bind:style="{'background-color': cotizacion.color}">
                            <b class="t-18-px">{{cotizacion.nombre | initialText}}</b>
                          </span>
                        </div>
                        <div class="col">
                          <p class="t-complementary t-14-px">
                            <span>{{cotizacion.nombre | createFolio(cotizacion.id_cliente)}}</span>
                            <br>
                            <span class="t-upper t-10-px t-base" v-if="cotizacion.fecha_creacion">Creado: {{cotizacion.fecha_creacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cotizacion.usuario_creador"> Por {{cotizacion.usuario_creador}}</span><span class="t-upper t-10-px t-base separador-fechas" v-if="cotizacion.fecha_creacion && cotizacion.fecha_modificacion"> / </span><span class="t-upper t-10-px t-base" v-if="cotizacion.fecha_modificacion">Editado: {{cotizacion.fecha_modificacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cotizacion.usuario_editor"> Por {{cotizacion.usuario_editor}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                 </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="clientes.length" class="container">
          <div class="row v-items-bottom">
            <div class="col">
              <p class="t-complementary">
                Clientes Recientes
              </p>
            </div>
            <div class="col-auto">
              <p>
                <a href="#" class="t-10-px link" v-on:click.prevent="goTo('/clientes')">
                  Ver Toda la Actividad
                </a>
              </p>
            </div>
          </div>
          <div class="row h-items-center">
            <div class="col-12 box-container b-white moves-container no-select">
              <ul class="list-container container">
                <li v-for="cliente in clientes" v-bind:key="cliente.id" class="row v-items-center">
                  <div class="col" v-on:click.prevent="goTo('/cliente/'+cliente.id)">
                    <div class="container">
                      <div class="row v-items-center">
                        <div class="col-auto">
                          <span class="icon-list" v-bind:style="{'background-color': cliente.color}">
                            <b class="t-18-px">{{cliente.nombre | initialText}}</b>
                          </span>
                        </div>
                        <div class="col">
                          <p class="t-complementary t-14-px">
                            <span v-if="cliente.empresa">{{cliente.empresa | cutText}}</span> <span v-if="cliente.nombre"> | {{cliente.nombre | cutText}}</span> <span v-if="cliente.contacto"> | {{cliente.contacto | cutText}}</span>
                            <br>
                            <span class="t-upper t-10-px t-base" v-if="cliente.fecha_creacion">Creado: {{cliente.fecha_creacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cliente.usuario_creador"> Por {{cliente.usuario_creador}}</span><span class="t-upper t-10-px t-base separador-fechas" v-if="cliente.fecha_creacion && cliente.fecha_modificacion"> / </span><span class="t-upper t-10-px t-base" v-if="cliente.fecha_modificacion">Editado: {{cliente.fecha_modificacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="cliente.usuario_editor"> Por {{cliente.usuario_editor}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                 </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import router from '@/router'
import { db } from '@/firebase'
export default {
  name: 'app',
  components: {
    GetFooter
  },
  data() {
    return {
      cotizaciones: [],
      clientes: []
    }
  },
  firestore () {
    return {
      cotizaciones: db.collection('cotizaciones').orderBy('fecha_modificacion', 'desc').limit(5),
      clientes: db.collection('clientes').orderBy('fecha_modificacion', 'desc').limit(5)
    }
  },
  methods: {
    goTo (url){
      router.push({path: url})
    },
  }
}
</script>